<template>
  <v-container fluid mx-0 pa-0 style="background: #fff">
    <v-row v-if="L_LoadIndice < L_LoadLimit"> {{ T_Message }} {{ L_LoadIndice }} / {{ L_LoadLimit }} </v-row>
    <v-row v-else-if="T_Message != ''">
      {{ T_Message }}
    </v-row>

    <v-row style="max-width: 98%; margin: 0px auto">
      <v-col cols="12" md="6" lg="4" style="height: 100%;background: #EEEEEE">
        <v-data-table v-model="selected" :headers="TO_Headers" :items="TO_Datalines" :single-select="singleSelect" :items-per-page="10">
          <template #item="{ item }">
            <tr :class="{ 'blue white--text font-weight-medium': item.id == L_EngageID }" @click="Fct_SelectRow(item)">
              <td>{{ IsisFct_Date2Display(item.dateLivraison) }}</td>
              <td>
                {{ item.nom }} <span style="color: #aaa">({{ item.code_frn }})</span>
              </td>
              <td>{{ item.libelle }}</td>
              <td style="text-align: right">{{ item.montantTotal }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12" md="6" lg="4" style="height: 100%;background: #FAFAFA">
        <div v-if="!B_Loaded" style="margin-top: 20px">
          <div style="width: 100px; margin: 0px auto">
            <v-img src="../../assets/equiload.gif" aspect-ratio="1"></v-img>
          </div>
          <div style="margin-top: 20px">
            <v-row v-if="L_LoadIndice < L_LoadLimit">
              <v-col lg="12" class="pa-1" style="text-align: center; color: #aaa">{{ T_Message }} {{ L_LoadIndice }} / {{ L_LoadLimit }}</v-col>
            </v-row>
            <v-row v-else-if="T_Message != ''">
              <v-col lg="12" class="pa-1" style="text-align: center; color: #aaa">{{ T_Message }}</v-col>
            </v-row>
          </div>
        </div>
        <div v-else>
          <div v-if="B_DataEmpty">
            <div style="margin-top: 20px">
              <v-row>
                <v-col lg="12" class="pa-1" style="text-align: center; color: #aaa">
                  <p>Il ne vous reste aucune approbation à effectuer</p>
                  <router-link :to="{ name: 'Engagement' }"><v-btn color="#444" style="color: #fff">retourner à la liste des engagements</v-btn></router-link>
                </v-col>
              </v-row>
            </div>
          </div>
          <v-form v-else v-model="B_Valid">
            <v-row>
              <v-spacer />
              <v-btn class="mr-2 my-4" color="green" style="color: #fff" @click="Fct_Validated">Approuver</v-btn>
              <v-btn class="mr-4 my-4" color="red" style="color: #fff" @click="Fct_Denied">Refuser</v-btn>
            </v-row>
            <v-text-field v-model="T_Commentaire" :rules="TO_CommentaireRules" :counter="250" label="Commentaire retour">
              <v-icon slot="append-outer" title="Ce commentaire sera lisible dans la liste des engagements" style="cursor: help"> mdi-information-outline </v-icon>
            </v-text-field>
            <v-divider class="mt-6"></v-divider>
            <v-row>
              <div class="mt-2 mb-4" style="width: 100%; text-align: center">Données encodées par l'émeteur</div>
            </v-row>
            <v-text-field v-model="T_Libelle" label="Libellé" class="IsisBlackReq" disabled></v-text-field>
            <v-text-field v-model="T_Provider" label="Fournisseur" class="IsisBlackReq" disabled></v-text-field>
            <v-row>
              <v-col cols="4">
                <v-text-field v-model="R_MontantTotal" label="Montant total engagé" class="IsisAlignRight IsisBlackReq" disabled></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="R_montantBudgetTotal" label="Budget total" class="IsisAlignRight IsisBlackReq" disabled></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="R_montantBudgetRemaining"
                  label="Restant budget total"
                  class="IsisAlignRight IsisBlackReq"
                  :background-color="B_BudgetOut ? '#FFCDD2' : ''"
                  disabled
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  v-model="T_AnalyticAccount"
                  :items="TO_AnalyticAccountList"
                  item-text="libelle_CA"
                  item-value="cpteAnalytique"
                  label="Compte Analytique"
                  :hint="`Compte '${T_AnalyticAccount}'`"
                  :rules="[v => !!v || 'Le compte analytique est requis']"
                  @change="Fct_SelectAccount"
                  persistent-hint
                  required
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-row v-if="TO_budgets.length <= 1">
                  <v-autocomplete
                    v-model="T_AnalyticNature"
                    :items="TO_AnalyticNatureList"
                    item-text="libelle_nature"
                    item-value="natureAnalytique"
                    label="Nature Analytique"
                    :hint="`Nature '${T_AnalyticNature}'`"
                    :rules="[v => !!v || 'La nature analytique est requise']"
                    @change="Fct_SelectNature"
                    class="mx-3"
                    persistent-hint
                    required
                    background-color="#FFF9C4"
                  ></v-autocomplete>
                </v-row>
                <v-row v-else class="d-flex justify-center align-center">
                  <v-btn @click="Fct_showNatures" color="primary" class="elevation-2" text>
                    Natures multiples
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
            <div v-if="T_File != ''">Fichier PDF attaché : <a :href="T_File" color="primary" style="text-decoration: none" target="_blank">Ouvrir</a></div>
            <v-text-field v-model="T_Description" label="Descriptif" class="mt-4 IsisBlackReq" disabled></v-text-field>
            <div v-if="B_BudgetOut" style="color: #cc0000; text-align: center">Cet engagement est hors budget (dépassement de {{ this.R_BudgetOver }} €)</div>
          </v-form>
        </div>
      </v-col>
      <v-col cols="12" md="6" lg="4" class="d-lg-flex" style="height: 100%;" v-show="L_EngageID != 0">
        <v-tabs>
          <v-tab href="#tab-1" @click="Fct_TabClick(1)">Détail</v-tab>
          <v-tab-item value="tab-1">
            <div class="pt-2">
              <v-card style="height: 12px; background: none" flat> </v-card>
              <v-text-field v-model="T_NameContact" label="Nom du contact sur place" hint="Nom de la personne qui sera contactée par le fournisseur"></v-text-field>
              <v-textarea v-model="T_TextIntro" label="Texte d'introduction" hint="Texte ajouté dans le document en pièce jointe du mail" rows="9"></v-textarea>
              <v-textarea v-model="T_RemarqueFrn" label="Remarque au Fournisseur" hint="Texte à destination du fournisseur" rows="7"></v-textarea>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="T_DateDisplay"
                    label="Date de livraison"
                    prepend-icon="mdi-calendar-month"
                    @focus="$event.target.select()"
                    @click:prepend="Fct_DatePickerOpen"
                    @blur="Fct_DateCheck"
                  ></v-text-field>
                  <v-dialog ref="dialog" v-model="B_DatePicker" persistent width="290px">
                    <v-date-picker v-model="T_DateSQL" scrollable locale="fr-fr">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="B_DatePicker = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="Fct_DatePickerSave(T_DateSQL)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="T_DateDisplayRecall"
                    label="Date de reprise"
                    prepend-icon="mdi-calendar-month"
                    @focus="$event.target.select()"
                    @click:prepend="Fct_DatePickerOpenRecall"
                    @blur="Fct_DateCheckRecall"
                  ></v-text-field>
                  <v-dialog ref="dialog" v-model="B_DatePickerRecall" persistent width="290px">
                    <v-date-picker v-model="T_DateSQLRecall" scrollable locale="fr-fr">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="B_DatePickerRecall = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="Fct_DatePickerSaveRecall(T_DateSQLRecall)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
          <v-tab href="#tab-2" @click="Fct_TabClick(2)">Engagements du budget</v-tab>
          <v-tab-item value="tab-2">
            <div class="pt-2">
              <v-row style="width: 98%; margin: 0px auto">
                <v-data-table v-model="TO_EngageSelected" :headers="TO_EngageHeaders" :items="TO_BudgetEngagements" :items-per-page="10">
                  <template #item.provider="{ item }">
                    <div>
                      {{ item.nom }} <span style="color: #aaa">({{ item.code_frn }})</span>
                    </div>
                  </template>
                  <template #item.action="{ item }">
                    <v-icon small class="mr-2" title="A envoyer pour appro" v-if="item.fk_Statut == 1"> mdi-timer-sand </v-icon>
                    <v-icon small class="mr-2" title="Envoyé pour appro" v-if="item.fk_Statut == 2"> mdi-camera-timer </v-icon>
                    <v-icon small class="mr-2" title="Approuvé" v-if="item.fk_Statut == 3" color="#00AA00"> mdi-check </v-icon>
                    <v-icon small class="mr-2" title="Refusé" v-if="item.fk_Statut == 4" color="#AA0000"> mdi-close </v-icon>
                    <a :href="item.file" target="_blank" style="text-decoration: none">
                      <v-icon small color="primary" title="Voir le fichier lié dans un autre onglet"> mdi-file-outline </v-icon>
                    </a>
                  </template>
                </v-data-table>
              </v-row>
              <v-row style="width: 98%; margin: 0px auto">
                <v-spacer />
                <v-icon small class="mr-2 ml-3" title="A envoyer pour appro"> mdi-timer-sand </v-icon>
                <div class="mt-1" style="font-size: 0.9em">A envoyer pour appro</div>
                <v-icon small class="mr-2 ml-3" title="Envoyé pour appro"> mdi-camera-timer </v-icon>
                <div class="mt-1" style="font-size: 0.9em">Envoyé pour appro</div>
              </v-row>
              <v-row style="width: 98%; margin: 0px auto">
                <v-spacer />
                <v-icon small class="mr-2 ml-3" title="Approuvé" color="#00AA00"> mdi-check </v-icon>
                <div class="mt-1" style="font-size: 0.9em">Approuvé</div>
                <v-icon small class="mr-2 ml-3" title="Refusé" color="#AA0000"> mdi-close </v-icon>
                <div class="mt-1" style="font-size: 0.9em">Refusé</div>
                <v-icon small class="mr-2 ml-3" color="primary" title="Ouvrir le fichier"> mdi-file-outline </v-icon>
                <div class="mt-1" style="font-size: 0.9em">Ouvrir le fichier</div>
              </v-row>
            </div>
          </v-tab-item>
          <v-tab href="#tab-3" @click="Fct_TabClick(3)">Offre fournisseur (PDF)</v-tab>
          <v-tab-item value="tab-3">
            <div class="pt-2">
              <object type="application/pdf" :data="T_File" width="100%" height="600px"></object>
            </div>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <popnatures ref="natures" :L_EngageID="L_EngageID" :TO_budgets="TO_budgets" :TO_AnalyticNatureList="TO_AnalyticNatureList" @update:TO_budgets="Fct_UpdateTOBudgets">
    </popnatures>
  </v-container>
</template>

<script>
import { MixinBudget } from "../../mixin/MixinBudget";
import { MixinBudgets } from "../../mixin/MixinBudgets";
import { MixinPeriods } from "../../mixin/MixinPeriods";
import popnatures from "./gestionNatures";

export default {
  mixins: [MixinBudget, MixinBudgets, MixinPeriods],
  components: { popnatures },
  name: "Engagement",
  data: () => ({
    B_Valid: false,
    L_UserID: 0,
    L_BudgetID: 0,
    L_EngageID: 0,
    T_Commentaire: "",
    TO_CommentaireRules: [v => v.length <= 250 || "Le commentaire doit avoir moins de 250 caractères"],
    T_Libelle: "Loading...",
    T_Provider: "Loading...",
    R_MontantTotal: 0,
    T_AnalyticAccount: "Loading...",
    TO_AnalyticAccountList: [],
    L_AnalyticAccountFKID: 0,
    T_AnalyticNature: "Loading...",
    TO_AnalyticNatureList: [],
    L_AnalyticNatureFKID: 0,
    T_Period: "Loading...",
    T_Description: "Loading...",
    T_Date: "Loading...",
    T_Date_Engage: "Loading...",
    T_File: "",
    singleSelect: false,
    selected: [],
    TO_Headers: [
      { text: "Date de livraison", align: "left", value: "dateLivraison" },
      { text: "Fournisseur", value: "provider", align: "left" },
      { text: "Libellé", value: "libelle" },
      { text: "Montant Engagé", value: "montant", align: "right" }
    ],
    TO_Datalines: [],
    B_Loaded: false,
    T_Message: "",
    L_LoadIndice: 0,
    L_LoadLimit: 0,
    L_ShowBudgetList: 0,
    T_ShowBudgetTitle: "Voir le PDF",
    TO_EngageSelected: [],
    TO_EngageHeaders: [
      { text: "Date de livraison", align: "left", value: "dateLivraison" },
      { text: "Fournisseur", value: "provider", align: "left" },
      { text: "Libellé", value: "libelle" },
      { text: "Montant Engagé", value: "montantTotal", align: "right" },
      { text: "Actions", value: "action", sortable: false, align: "right" }
    ],
    T_NameContact: "",
    T_TextIntro: "",
    T_RemarqueFrn: "",
    T_DateSQL: new Date().toISOString().substr(0, 10),
    T_DateDisplay: "",
    B_DatePicker: false,
    T_DateSQLRecall: new Date().toISOString().substr(0, 10),
    T_DateDisplayRecall: "",
    B_DatePickerRecall: false,
    T_DateApprobation: new Date().toISOString().substr(0, 10),

    TO_budgets: [
      {
        fk_engagement: 0,
        fk_budget: 0,
        fk_NatureAnalytique: 0,
        code_nature: "",
        montant: 0,
        montant_budget: 0,
        montant_restant_budget: 0,
        engagements_count_budget: 0,
        engagements_pk_budget: []
      }
    ],
    R_montantBudgetTotal: 0,
    R_montantBudgetRemaining: 0
  }),
  computed: {
    B_DataEmpty: function() {
      return this.TO_Datalines.length == 0;
    },
    R_BudgetOver: function() {
      return 0 - this.R_montantBudgetRemaining;
    },
    B_BudgetOut: function() {
      return this.R_montantBudgetRemaining < 0;
    }
  },
  methods: {
    Fct_showNatures() {
      this.$refs.natures.show();
    },
    Fct_UpdateTOBudgets(updatedBudgets) {
      this.TO_budgets = updatedBudgets;

      this.R_MontantTotal = 0;
      this.R_montantBudgetTotal = 0;
      this.R_montantBudgetRemaining = 0;
      for (var L_Index = 0; L_Index < this.TO_budgets.length; L_Index++) {
        this.R_MontantTotal += parseFloat(this.TO_budgets[L_Index].montant);
        this.R_montantBudgetTotal += parseFloat(this.TO_budgets[L_Index].montant_budget);
        this.R_montantBudgetRemaining += parseFloat(this.TO_budgets[L_Index].montant_restant_budget);
      }

      this.R_MontantTotal = this.R_MontantTotal.toFixed(2);
      this.R_montantBudgetTotal = this.R_montantBudgetTotal.toFixed(2);
      this.R_montantBudgetRemaining = this.R_montantBudgetRemaining.toFixed(2);

      if (this.TO_budgets.length == 1) {
        this.L_BudgetID = this.TO_budgets[0].fk_budget;
        this.T_AnalyticNature = this.TO_budgets[0].code_nature;
        this.Fct_SelectNature();
      } else {
        this.L_BudgetID = 0;
        this.L_AnalyticNatureFKID = 0;
        this.T_AnalyticNature = "";
      }

      //this.B_BudgetLoaded = true; //this.Fct_BudgetLoad(this.L_BudgetID, true);
      this.Fct_BudgetsEngageList(this.TO_budgets.map(item => item.fk_budget));
    },
    Fct_Loading() {
      // vérifie l'avancement du chargement de la page
      var B_Loaded = false;

      //if(!this.ProvidersLoaded) { this.T_Message = 'Chargement des Fournisseurs'; }
      //else { B_Loaded = true; }
      B_Loaded = true;
      if (B_Loaded) {
        this.Fct_Launch();
        this.T_Message = "";
      } else {
        setTimeout(this.Fct_Loading, 500);
      }
    },
    Fct_Launch() {
      this.TO_AnalyticAccountList = this.TO_BudgetsList;
      this.Fct_GetApprobation();
    },
    Fct_GetApprobation() {
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("engagements/approblist/", { headers: { Authorization: T_Token } })
        .then(response => {
          this.TO_Datalines = response.data;
          /*this.TO_Datalines = [];
          for (var L_Index = 0; L_Index < response.data.length; L_Index++) {
            response.data[L_Index].dateLivraison = this.IsisFct_Date2Display(response.data[L_Index].dateLivraison);
            this.TO_Datalines.push(response.data[L_Index]);
          }*/

          this.Fct_SelectFirstRow();
          this.B_Loaded = true;
        })
        .catch(() => {
          this.$router.push({ name: "Disconnect" });
        });
      this.T_Commentaire = "";
    },
    Fct_SelectFirstRow() {
      if (this.TO_Datalines.length > 0) {
        this.Fct_SelectRow(this.TO_Datalines[0]);
      } else {
        this.L_EngageID = 0;
        //this.$root.$children[0].IsisInfo("Vous n'avez plus aucune approbation à effectuer", "warning");
      }
    },
    Fct_SelectRow(O_DataLine) {
      this.L_EngageID = O_DataLine.id;
      this.T_Libelle = O_DataLine.libelle;
      this.T_Provider = O_DataLine.nom + " (" + O_DataLine.code_frn + ")";
      this.T_Description = O_DataLine.descriptif;
      this.T_Date_Engage = this.IsisFct_Date2Display(O_DataLine.dateEngagement);
      this.T_File = O_DataLine.file;
      this.T_NameContact = O_DataLine.contactSurPlace;
      this.T_TextIntro = O_DataLine.texteIntro;
      this.T_RemarqueFrn = O_DataLine.remarqueFrn;
      this.T_DateSQL = O_DataLine.dateLivraison;
      this.T_DateDisplay = this.IsisFct_Date2Display(this.T_DateSQL);
      this.T_DateSQLRecall = O_DataLine.dateReprise;
      this.T_DateDisplayRecall = this.IsisFct_Date2Display(this.T_DateSQLRecall);

      /*this.L_BudgetID = O_DataLine.fk_Budget;
      this.T_AnalyticNature = O_DataLine.code_nature;
      this.T_Period = O_DataLine.periodeBudget;
      this.R_MontantTotal = O_DataLine.montant;

      this.Fct_BudgetLoad(this.L_BudgetID, true);
      this.TO_AnalyticAccountList = this.BudgetsLoadByUserApprob(this.L_UserID);
      this.Fct_GetBudget();
      this.Fct_BudgetEngageList();*/

      this.R_MontantTotal = O_DataLine.montantTotal;

      this.T_AnalyticAccount = O_DataLine.code_CA;
      this.Fct_SelectAccount();

      this.TO_budgets = O_DataLine.budgets;

      this.R_montantBudgetTotal = 0;
      this.R_montantBudgetRemaining = 0;
      for (var L_Index = 0; L_Index < this.TO_budgets.length; L_Index++) {
        this.R_montantBudgetTotal += parseFloat(this.TO_budgets[L_Index].montant_budget);
        this.R_montantBudgetRemaining += parseFloat(this.TO_budgets[L_Index].montant_restant_budget);
      }

      this.R_montantBudgetTotal = this.R_montantBudgetTotal.toFixed(2);
      this.R_montantBudgetRemaining = this.R_montantBudgetRemaining.toFixed(2);

      if (this.TO_budgets.length == 1) {
        this.L_BudgetID = this.TO_budgets[0].fk_budget;
        this.T_AnalyticNature = this.TO_budgets[0].code_nature;
        this.Fct_SelectNature();
      } else {
        this.L_BudgetID = 0;
        this.L_AnalyticNatureFKID = 0;
        this.T_AnalyticNature = "";
      }

      //this.B_BudgetLoaded = true; //this.Fct_BudgetLoad(this.L_BudgetID, true);
      this.Fct_BudgetsEngageList(this.TO_budgets.map(item => item.fk_budget));
    },
    Fct_Validated() {
      let O_FormData = new FormData();
      O_FormData.append("fk_Statut", 3); // 3 = Approuvé
      O_FormData.append("commentaireApprobateur", this.T_Commentaire);
      O_FormData.append("remarqueFrn", this.T_RemarqueFrn);
      O_FormData.append("texteIntro", this.T_TextIntro);
      O_FormData.append("contactSurPlace", this.T_NameContact);
      O_FormData.append("dateLivraison", this.T_DateSQL);
      O_FormData.append("dateReprise", this.T_DateSQLRecall);
      O_FormData.append("fk_CpteAnalytique", this.L_AnalyticAccountFKID);
      O_FormData.append("fk_UserApprobation", this.L_UserID);
      O_FormData.append("dateApprobation", this.T_DateApprobation);

      //O_FormData.append("fk_Budget", this.L_BudgetID);
      //O_FormData.append("fk_NatureAnalytique", this.L_AnalyticNatureFKID);

      O_FormData.append("budgets", JSON.stringify(this.TO_budgets));

      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .patch("engagements/" + this.L_EngageID + "/", O_FormData, { headers: { Authorization: T_Token } })
        .then(O_Response => {
          if (O_Response != null) {
            this.Fct_GetApprobation();
          }
        })
        .catch(T_Error => {
          this.$root.$children[0].IsisInfo("Une erreur est survenue (" + T_Error + ")", "error");
        });
    },
    Fct_Denied() {
      let O_FormData = new FormData();
      O_FormData.append("fk_Statut", 4); // 4 = Refusé
      O_FormData.append("commentaireApprobateur", this.T_Commentaire);

      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .patch("engagements/" + this.L_EngageID + "/", O_FormData, { headers: { Authorization: T_Token } })
        .then(O_Response => {
          if (O_Response != null) {
            this.Fct_GetApprobation();
          }
        })
        .catch(T_Error => {
          this.$root.$children[0].IsisInfo("Une erreur est survenue (" + T_Error + ")", "error");
        });
    },
    Fct_TabClick(tab) {
      if (tab == 1) {
        // Détail
      } else if (tab == 2) {
        // Engagements du budget
        //this.Fct_BudgetEngageList();
      } else {
        // Offre fournisseur
      }
    },
    Fct_DatePickerOpen() {
      //alert('Date');
      this.B_DatePicker = true;
    },
    Fct_DateCheck() {
      this.T_DateDisplay = this.IsisFct_DateCheck(this.T_DateDisplay);
      this.T_DateSQL = this.IsisFct_Date2SQL(this.T_DateDisplay);
    },
    Fct_DatePickerSave() {
      //alert('Date');
      //$refs.dialog.save(this.T_DateSQL)
      this.T_DateDisplay = this.IsisFct_Date2Display(this.T_DateSQL);
      this.B_DatePicker = false;
    },
    Fct_DatePickerOpenRecall() {
      //alert('Date');
      this.B_DatePickerRecall = true;
    },
    Fct_DateCheckRecall() {
      this.T_DateDisplayRecall = this.IsisFct_DateCheck(this.T_DateDisplayRecall);
      this.T_DateSQLRecall = this.IsisFct_Date2SQL(this.T_DateDisplayRecall);
    },
    Fct_DatePickerSaveRecall() {
      //alert('Date');
      //$refs.dialog.save(this.T_DateSQL)
      this.T_DateDisplayRecall = this.IsisFct_Date2Display(this.T_DateSQLRecall);
      this.B_DatePickerRecall = false;
    },
    Fct_SelectAccount() {
      //this.L_BudgetID = 0;
      //this.L_AnalyticAccountFKID = this.BudgetsGetFKAccount(this.T_AnalyticAccount);
      //this.TO_AnalyticNatureList = this.BudgetsFilterGetByAccount(this.T_Period, this.T_AnalyticAccount);

      this.L_BudgetID = 0;
      this.R_montantBudgetTotal = 0;
      this.R_montantBudgetRemaining = 0;

      this.L_AnalyticAccountFKID = this.BudgetsGetFKAccount(this.T_AnalyticAccount);
      this.TO_AnalyticNatureList = this.BudgetsFilterGetByPeriodYearAccount(this.T_Period, this.T_AnalyticAccount);

      this.L_AnalyticNatureFKID = 0;
      this.T_AnalyticNature = "";

      this.TO_budgets = [
        {
          fk_engagement: 0,
          fk_budget: 0,
          fk_NatureAnalytique: 0,
          code_nature: "",
          montant: 0,
          montant_budget: 0,
          montant_restant_budget: 0,
          engagements_count_budget: 0,
          engagements_pk_budget: []
        }
      ];
    },
    Fct_SelectNature() {
      //this.L_AnalyticNatureFKID = this.BudgetsGetFKNature(this.T_AnalyticNature);
      //this.L_BudgetID = this.BudgetsGetIDFromNature(this.T_AnalyticNature, this.TO_AnalyticNatureList);

      const self = this;
      this.L_AnalyticNatureFKID = this.BudgetsGetFKNature(this.T_AnalyticNature);
      this.L_BudgetID = this.BudgetsGetIDFromNature(this.T_AnalyticNature, this.TO_AnalyticNatureList);
      this.BudgetsHowFarOut(this.L_BudgetID, this.R_MontantTotal, this.L_EngageID).then(function() {
        if (self.TO_budgets.length == 1) {
          self.TO_budgets[0].fk_budget = self.L_BudgetID;
          self.TO_budgets[0].fk_NatureAnalytique = self.L_AnalyticNatureFKID;
          self.TO_budgets[0].code_nature = self.T_AnalyticNature;
          self.TO_budgets[0].montant = self.R_MontantTotal;
          self.TO_budgets[0].montant_budget = self.R_montantBudgetTotal;
          self.TO_budgets[0].montant_restant_budget = self.R_montantBudgetRemaining;
          self.TO_budgets[0].engagements_count_budget = self.L_BudgetsCounter;
          self.TO_budgets[0].engagements_pk_budget = [];
        }
      });
      //this.BudgetsIsAllowed(this.L_BudgetID, this.L_UserID);
    }
  },
  created() {
    // Les variables sont chargées mais pas le DOM
    this.B_SuperAdmin = this.$cookies.get("UserAdmin") == "true";
    this.T_Period = this.$cookies.get("Period");
    this.L_UserID = this.$cookies.get("UserID");
  },
  mounted() {
    // Le DOM est chargé
    const self = this;
    this.Fct_PeriodsLoad().then(function() {
      self.BudgetsLoadByYearAndUser(self.T_Period).then(function() {
        self.Fct_Loading();
      });
    });
  }
};
</script>

<style>
.IsisAlignRight input {
  text-align: right;
}

.IsisBlackReq input {
  color: #000 !important;
}

.IsisUnlocked {
  pointer-events: auto;
}
</style>
